export enum ProductionKeyPerformanceIndicatorTypeEnum {
  PERSONAL = 'personal',
  COMPANY_PRODUCT = 'company_product',
  COMPANY_PRODUCT_PERSONAL = 'company_product_personal',
}

export const ProductionKeyPerformanceIndicatorTypeEnumLabels: Record<string, string> = {
  [ProductionKeyPerformanceIndicatorTypeEnum.PERSONAL]: 'Personal',
  [ProductionKeyPerformanceIndicatorTypeEnum.COMPANY_PRODUCT]: 'Producto',
  [ProductionKeyPerformanceIndicatorTypeEnum.COMPANY_PRODUCT_PERSONAL]: 'Producto Personal',
};
